import * as THREE from "three";
import { MathUtils, Vector3 } from "three";
import { generateUUID } from "three/src/math/MathUtils";
import { IndserObject, IndsertPosition } from "@/core/IndserObject";
import { MLayer } from "@/core/MLayer";
import {
  DBEntity,
  DbLayer,
  DbLine,
  FMathUtils,
  ModelManager,
  ViewManager,
} from "@/CadEngine";
import { BPMathUtils } from "@/utils/BPMathUtils";
import {
  DrawOperateState,
  IDrawOperation,
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
} from "../IDrawOperation";
import { BPLinear } from "@/core/BPLinear";
import { Context } from "@/core/context";
import { LineDimension } from "@/Dimensions/LineDimension";
import { ArcDimension } from "@/Dimensions/ArcDimension";
import { AnchorPointAux } from "@/Dimensions/AnchorPointAuxs";
import { OrthogonalAux } from "@/Dimensions/OrthogonalAux";
import { ULabel } from "@/ui/ULabel";
import { ProtectRadius } from "./ProtectRadius";
import { ActiveInputType, CommonColor, FinishResult } from "@/core/Parameters";
import { DimensionGroup } from "@/core/DimensionGroup";

class DrawLineLayout {
  private m_model: ModelManager;
  private m_layer: DbLayer;
  private m_auxLayer: MLayer;
  private m_material: THREE.LineBasicMaterial;
  private m_tempObject: THREE.Line | undefined;
  private m_geometry: THREE.BufferGeometry | undefined;
  private points: THREE.Vector3[] = [];
  private m_locationObject: THREE.Line;
  private m_size = { x: 1, y: 1, z: 1 };
  private view: ViewManager;
  private m_auxPoints: {
    orgin: THREE.Vector3;
    dir: THREE.Vector3 | undefined;
  }[] = [];
  private m_curPoint: THREE.Vector3 = new THREE.Vector3();
  private m_dimension: DimensionGroup;
  private m_context: Context;
  private AuxPointGroup: THREE.Group;
  private m_specialParams: any;
  private ProtectRadiusGroup: THREE.Group;
  private m_activeInputType: ActiveInputType = ActiveInputType.None;
  private m_inputValue: string = "";
  private m_distanceInputValue: string = "";
  private m_angleInputValue: string = "";
  private m_quadraturePoint: THREE.Vector3 | undefined = undefined;
  private m_isEnter: boolean = false;
  private m_color: number;
  private m_TextLabel: ULabel;
  private m_isShift: Boolean = false;
  constructor(
    context: Context,
    layer: DbLayer,
    color: number,
    specialParams?: any
  ) {
    this.m_context = context;
    this.m_model = context.ModelManager;
    this.m_layer = layer;
    this.m_color = color;
    this.m_auxLayer = context.SceneManager.AuxModel;
    this.m_material = new THREE.LineBasicMaterial({
      color: new THREE.Color(color),
    });
    this.m_locationObject = context.ToolsManager.CreatedLocationLine();
    this.view = context.ViewManager;
    this.m_dimension = new DimensionGroup(this.view, this.m_auxLayer);
    this.m_dimension.Line.SetVaule("");
    this.m_dimension.Arc.SetVaule("");
    this.AuxPointGroup = new THREE.Group();
    this.m_auxLayer.add(this.AuxPointGroup);
    this.m_specialParams = specialParams;
    this.createDistanceLabel();
    this.ProtectRadiusGroup = new THREE.Group();
    this.m_auxLayer.add(this.ProtectRadiusGroup);
    this.m_context.Dom.style.cursor = "none";
    this.m_TextLabel = new ULabel(
      this.m_context.ViewManager,
      this.m_context.Dom
    );
    this.m_TextLabel.Visibility = true;
  }

  SetDrawLineForDashed() {}
  onMouseMove(e: PointerEvent): void {}
  onKeyDown(e: KeyboardEvent): void {
    e.preventDefault();
    if (e.keyCode == 16) {
      this.m_isShift = true;
    }
    if (this.points.length == 0) return;
    if (this.points.length >= 2) return;
    if (e.key === "Tab") {
      this.m_inputValue = "";
      if (this.m_activeInputType == ActiveInputType.None) {
        this.m_activeInputType = ActiveInputType.Distance;
        this.m_dimension.Line.Input.Dom.style.border = "1px solid #ffffff";
        this.m_dimension.Arc.Input.Dom.style.border = "1px solid #101010";
      } else if (this.m_activeInputType == ActiveInputType.Distance) {
        this.m_activeInputType = ActiveInputType.Angle;
        this.m_dimension.Line.Input.Dom.style.border = "1px solid #101010";
        this.m_dimension.Arc.Input.Dom.style.border = "1px solid #ffffff";
      } else if (this.m_activeInputType == ActiveInputType.Angle) {
        this.m_activeInputType = ActiveInputType.Distance;
        this.m_dimension.Line.Input.Dom.style.border = "1px solid #ffffff";
        this.m_dimension.Arc.Input.Dom.style.border = "1px solid #101010";
      }
    }
    if (e.key == "Backspace") {
      if (this.m_inputValue.length > 0) {
        this.m_inputValue = this.m_inputValue.substring(
          0,
          this.m_inputValue.length - 1
        );
      }
      if (this.m_activeInputType == ActiveInputType.Distance) {
        this.m_dimension.Line.Input.SetVaule(this.m_inputValue);
        if (this.m_inputValue) {
          this.m_distanceInputValue = this.m_inputValue;
        }
      } else if (this.m_activeInputType == ActiveInputType.Angle) {
        this.m_dimension.Arc.Input.SetVaule(this.m_inputValue + " °");
        if (this.m_inputValue) {
          this.m_angleInputValue = this.m_inputValue;
        }
      }
    } else if ((e.key >= "0" && e.key <= "9") || e.key == ".") {
      if (this.m_activeInputType == ActiveInputType.None) return;
      if (this.m_inputValue?.includes(".") && e.key == ".") return;
      this.m_inputValue += e.key;
      if (this.m_activeInputType == ActiveInputType.Distance) {
        this.m_dimension.Line.Input.SetVaule(this.m_inputValue);
        this.m_distanceInputValue = this.m_inputValue;
      } else if (this.m_activeInputType == ActiveInputType.Angle) {
        this.m_dimension.Arc.Input.SetVaule(this.m_inputValue + " °");
        this.m_angleInputValue = this.m_inputValue;
      }
    } else if (e.key == "Enter") {
      let length = parseFloat(this.m_distanceInputValue) * 0.001;
      let position = this.m_locationObject.position.clone();
      let curDir = position
        .clone()
        .sub(this.points[this.points.length - 1])
        .normalize();
      let angle = curDir.angleTo(new THREE.Vector3(1, 0, 0));
      if (curDir.clone().cross(new THREE.Vector3(1, 0, 0)).z > 0) {
        angle = -angle;
      }
      curDir.applyAxisAngle(new THREE.Vector3(0, 0, 1), -angle);
      curDir.applyAxisAngle(
        new THREE.Vector3(0, 0, 1),
        MathUtils.degToRad(parseFloat(this.m_angleInputValue))
      );
      position = this.points[this.points.length - 1]
        .clone()
        .add(curDir.multiplyScalar(length));

      this.m_isEnter = true;
      this.m_quadraturePoint = undefined;
      this.OnMovePoint({
        point: position,
        geo: undefined,
        position: IndsertPosition.None,
      });
      this.m_isEnter = false;
      this.points.push(position);
      this.view.Render();
    }
  }
  onKeyUp(e: KeyboardEvent): void {
    if (e.keyCode == 16) {
      this.m_isShift = false;
    }
  }

  private get originPoint() {
    return this.points[0];
  }

  private get curDir() {
    return this.m_curPoint.clone().sub(this.originPoint).normalize();
  }
  private drawLineAux: THREE.Line | undefined;
  private SignMatrixs: THREE.Matrix4[] = [];

  OnZoom(camera: THREE.Camera) {
    this.m_auxPoints = [];
  }
  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {
    let tolSq = params.tol * params.tol;
    if (this.points.length > 0 && this.points.length <= 2) {
      let start = new THREE.Vector3();
      let end = new THREE.Vector3();
      let target = new THREE.Vector3();
      let targetOnSegment = new THREE.Vector3();
      let point = this.points[this.points.length - 1];
      if (this.points.length > 1) {
        for (let index = 0; index < this.points.length - 1; index++) {
          start.copy(this.points[index]);
          end.copy(this.points[index + 1]);
          let distance = params.ray.distanceSqToSegment(
            start,
            end,
            target,
            targetOnSegment
          ); // target在射线上，targetOnSegment在线段上
          //  console.log(target.x,target.y,target.z+'          '+targetOnSegment.x,targetOnSegment.y,targetOnSegment.z)
          if (distance <= tolSq) {
            // let location = {x:Number(target.x.toFixed(3)), y:Number(target.y.toFixed(3)), z:Number(target.z.toFixed(3))};
            let location = {
              x: Number(targetOnSegment.x.toFixed(3)),
              y: Number(targetOnSegment.y.toFixed(3)),
              z: Number(targetOnSegment.z.toFixed(3)),
            };
            let center = new THREE.Vector3(
              (start.x + end.x) * 0.5,
              (start.y + end.y) * 0.5,
              (start.z + end.z) * 0.5
            );
            let d1 = start.distanceTo(targetOnSegment);
            let d2 = center.distanceTo(targetOnSegment);
            let d3 = end.distanceTo(targetOnSegment);
            let position = IndsertPosition.None;
            let min = Math.min(d1, d2, d3);
            let adjust = targetOnSegment.clone();
            if (min <= params.tol) {
              if (min == d1) {
                position = IndsertPosition.Start;
                adjust = start.clone();
              }
              if (min == d2) {
                position = IndsertPosition.Center;
                adjust = center;
              }
              if (min == d3) {
                position = IndsertPosition.End;
                adjust = end.clone();
              }
            }
            let insert = new IndserObject(location, distance, "", []);
            insert.adjust = adjust;
            insert.position = position;
            insert.geo = new THREE.Line3(start.clone(), end.clone());
            params.array.push(insert);
          }
        } // 以上先是用当前移动线检测是否和自己画的线段相交，不包括最后一个线段

        //夹角矫正
        {
          // 这段代码作用为用当前移动线段来和自己画的线的最后一段线检测是否相交
          // alert('yyyyyyyy')
          let direction = new THREE.Vector3();
          this.view.Camera.getWorldDirection(direction);
          let line = new THREE.Line3(
            this.points[this.points.length - 2].clone(),
            this.points[this.points.length - 1].clone()
          );
          let p0 = new THREE.Vector3();
          let p = params.ray.intersectPlane(new THREE.Plane(direction, 0), p0);
          let dir0 = line.end.clone().sub(line.start).normalize();
          let dir1 = p0.clone().sub(line.end).normalize();
          let rad = BPMathUtils.angleTo(dir0, dir1, direction);
          let angle = (rad * 180) / Math.PI;
          let orginLength = p0.distanceTo(line.end);
          let tolAngle = (((params.tol / orginLength) * 180) / Math.PI) * 2; // orginLength越小自动偏转幅度越大

          let offsetAngle = (angle + tolAngle) % 90;
          if (offsetAngle <= tolAngle * 2) {
            //五度之内视为垂直
            rad = rad - ((offsetAngle - tolAngle) * Math.PI) / 180;
            let p = dir0
              .applyAxisAngle(direction, rad)
              .multiplyScalar(p0.distanceTo(line.end));

            p = line.end.clone().add(dir0);
            let insert = new IndserObject(
              p,
              Math.sqrt(params.ray.distanceSqToPoint(p)),
              "",
              []
            );
            insert.adjust = p;
            insert.position = IndsertPosition.AuxOrthogonal;
            params.array.push(insert);
          }
        }
      }
      //正交矫正
      {
        // 这段代码作用为 当只有一个点的时候移动线段和 X轴的相交情况
        let direction = new THREE.Vector3();
        this.view.Camera.getWorldDirection(direction);
        let start = this.points[this.points.length - 1].clone();
        let p0 = new THREE.Vector3();
        params.ray.intersectPlane(new THREE.Plane(direction, 0), p0);
        let dir0 = new THREE.Vector3(1, 0, 0);
        let dir1 = p0.clone().sub(start).normalize();
        let rad = BPMathUtils.angleTo(dir0, dir1, direction);
        let angle = (rad * 180) / Math.PI;
        let orginLength = p0.distanceTo(start);
        let tolAngle = (((params.tol / orginLength) * 180) / Math.PI) * 2;
        let offsetAngle = (angle + tolAngle) % 90;

        if (offsetAngle <= tolAngle * 2) {
          //五度之内视为垂直
          rad = rad - ((offsetAngle - tolAngle) * Math.PI) / 180;
          let p = dir0
            .applyAxisAngle(direction, rad)
            .multiplyScalar(p0.distanceTo(start));
          p = start.clone().add(dir0);
          let insert = new IndserObject(
            p,
            Math.sqrt(params.ray.distanceSqToPoint(p)),
            "",
            []
          );
          insert.adjust = p;
          insert.position = IndsertPosition.AuxOrthogonal;
          // insert.geo = new THREE.Line3(start.clone(), end.clone());
          params.array.push(insert);
        }
      }
    }
    let ray = new THREE.Ray();

    /**
     * 辅助点的吸附点
     */
    if (this.m_auxPoints.length > 0) {
      let normal = new THREE.Vector3(0, 0, 1);
      let panel = new THREE.Plane(normal, 0);
      let insertPoint = new THREE.Vector3();
      params.ray.intersectPlane(panel, insertPoint);

      let func = (line: BPLinear, position: IndsertPosition) => {
        let target = new THREE.Vector3();
        let dis = line.distanceSqPoint(insertPoint, target); //line.distanceSqToRay(params.ray, target);
        if (dis <= tolSq) {
          let insert = new IndserObject(target, Math.sqrt(dis), "", []);
          insert.adjust = target;
          insert.position = position;
          insert.geo = line;
          params.array.push(insert);
        }
      };

      this.m_auxPoints.forEach((item) => {
        if (item.orgin && item.dir) {
          if (
            item.dir.distanceTo(new THREE.Vector3(1, 0, 0)) <= 0.0000001 ||
            item.dir.distanceTo(new THREE.Vector3(-1, 0, 0)) <= 0.0000001 ||
            item.dir.distanceTo(new THREE.Vector3(0, 1, 0)) <= 0.0000001 ||
            item.dir.distanceTo(new THREE.Vector3(0, -1, 0)) <= 0.0000001
          ) {
            func(
              new BPLinear(item.orgin, item.dir),
              IndsertPosition.AuxVertical
            );
            func(
              new BPLinear(
                item.orgin,
                item.dir.clone().applyAxisAngle(normal, Math.PI * 0.5)
              ),
              IndsertPosition.AuxVertical
            );
          } else {
            func(
              new BPLinear(item.orgin, item.dir),
              IndsertPosition.AuxVertical
            );
            func(
              new BPLinear(
                item.orgin,
                item.dir.clone().applyAxisAngle(normal, Math.PI * 0.5)
              ),
              IndsertPosition.AuxVertical
            );
            func(
              new BPLinear(item.orgin, new THREE.Vector3(1, 0, 0)),
              IndsertPosition.AuxOrthogonal
            );
            func(
              new BPLinear(item.orgin, new THREE.Vector3(0, 1, 0)),
              IndsertPosition.AuxOrthogonal
            );
          }
        }
      });
    }

    params.array.forEach((item) => {
      if (item.position == "none") item.position = IndsertPosition.Insert;
      if (item.geo) {
        if (item.geo instanceof THREE.Line3) {
          let line = item.geo as THREE.Line3;
          let p0 = item.adjust ?? item.location;
          let v0 = line.start.clone().sub(line.end.clone());
          let dir0 = v0.clone().normalize();
          if (this.points.length > 0) {
            let point = this.points[this.points.length - 1];
            let v1 = new THREE.Vector3(
              p0.x - point.x,
              p0.y - point.y,
              p0.z - point.z
            );
            let offset = dir0.multiplyScalar(v1.dot(dir0));
            if (offset.lengthSq() <= params.tol * params.tol) {
              //正交矫正
              item.position = IndsertPosition.Vertical;
              item.adjust = new THREE.Vector3(
                p0.x - offset.x,
                p0.y - offset.y,
                p0.z - offset.z
              );
            }
          }
          ray.set(line.start, line.end.clone().sub(line.start).normalize()); // 这里开始检测移动线段是否和场景中两个或两个以上的交点处接触
          params.array.forEach((item1) => {
            if (item1.geo instanceof THREE.Line3) {
              let line1 = item1.geo as THREE.Line3;
              // console.log(params,line,line1,line.start.clone().distanceTo(line1.start.clone()),'!!!!!!!!!');
              if (
                line != line1 &&
                line.start.clone().distanceTo(line1.start.clone()) >
                  0.0000000001 &&
                line.end.clone().distanceTo(line1.end.clone()) >
                  0.00000000001 &&
                line.start.y != line1.end.y
              ) {
                let target = new THREE.Vector3();
                let target1 = new THREE.Vector3();
                let distance = ray.distanceSqToSegment(
                  line1.start.clone(),
                  line1.end.clone(),
                  target
                );
                if (distance < 0.00000000001) {
                  line.closestPointToPoint(target, true, target1); //
                  if (target.distanceTo(target1) < 0.00000001) {
                    // 说明这两条线交叉了，因为这个点同时在两根线上
                    item.position = IndsertPosition.Cross;
                    item.adjust = target;
                    item.distance = target.distanceTo(
                      new THREE.Vector3(
                        item.location.x,
                        item.location.y,
                        item.location.z
                      )
                    );
                  }
                }
              }
            }
          });
        }
      }
    });
  }
  OnMovePoint(params: DrawOperationMovePointParams): void {
    this.m_locationObject.position.copy(params.point);
    this.m_locationObject.visible = true;
    let TextLabelLocation = new THREE.Vector3();
    TextLabelLocation.x = params.point.x + this.scale * 35;
    TextLabelLocation.y = params.point.y - this.scale * 10;
    this.m_TextLabel.SetVaule(
      "长按Shift锁定正交",
      TextLabelLocation,
      new THREE.Vector3(1, 0, 0)
    );
    if (!this.points.length) return;
    if (this.points.length >= 2) {
      this.OnWheel();
      return;
    }
    this.m_curPoint.copy(params.point);
    let ps = [];
    ps.push(...this.points);
    let paramsClone = params.point.clone();
    paramsClone.sub(this.points[this.points.length - 1].clone()).normalize();
    if (this.drawLineAux) {
      if (
        (this.m_context.DrawManager.isEnableQuadrature || this.m_isShift) &&
        !this.m_isEnter
      ) {
        this.m_curPoint = this.m_context.ToolsManager.GetOrthogonalityPoint(
          params.point,
          ps[ps.length - 1]
        );
      }
      let arr = [ps[ps.length - 1], this.m_curPoint];

      this.drawLineAux.geometry.setFromPoints(arr);
      this.drawLineAux.computeLineDistances();
    }

    if (this.m_geometry) {
      this.m_geometry.setFromPoints(ps);
      this.m_tempObject!.computeLineDistances();
    } else {
      this.m_geometry = new THREE.BufferGeometry();
      this.m_geometry.setFromPoints(ps);
      this.m_tempObject = new THREE.Line(this.m_geometry, this.m_material);
      this.m_tempObject.computeLineDistances();
      this.m_tempObject.frustumCulled = false;
      this.m_auxLayer.add(this.m_tempObject);
    }
    this.m_inputValue = "";
    this.updateDistanceAuxPoint();
    this.m_dimension.Line.SetDimension(
      this.originPoint,
      this.m_curPoint,
      this.scale
    );
    let xAxis = new THREE.Vector3(1, 0, 0);

    this.m_dimension.Arc.SetDimension(
      this.originPoint,
      new THREE.Vector3(1, 0, 0),
      this.curDir,
      this.scale
    );
    this.m_dimension.Anchor.SetPoint(this.auxPoint, this.scale);
    let angle = this.curDir.clone().angleTo(xAxis);
    if (this.curDir.clone().cross(xAxis).z > 0) {
      angle = Math.PI * 2 - angle;
    }
    angle = (angle / Math.PI) * 180;
    let distance = (this.m_curPoint.distanceTo(this.originPoint) * 1000)
      .toFixed(2)
      .toString();
    this.m_dimension.Line.SetVaule(distance);
    this.m_distanceInputValue = distance;
    this.m_dimension.Arc.SetVaule(angle.toFixed(0).toString());
    this.m_angleInputValue = angle.toFixed(0).toString();
    this.m_activeInputType = ActiveInputType.None;
    this.m_dimension.Line.Input.Dom.style.border = "1px solid #101010";
    this.m_dimension.Arc.Input.Dom.style.border = "1px solid #101010";
    this.m_inputValue = "";
  }
  OnDownPoint(params: DrawOperationMovePointParams): void {
    if (this.points.length >= 2) return;
    let { point } = params;
    if (
      (this.m_context.DrawManager.isEnableQuadrature || this.m_isShift) &&
      params.position == "none"
    ) {
      point = this.m_curPoint;
    } else {
      this.m_curPoint.copy(point);
    }
    this.points.push(point);
    if (this.points.length == 1) {
      this.createdMoveLineAux();
    } else if (this.points.length == 2) {
      this.drawLineAux!.geometry.setFromPoints(this.points);
      this.updateDistanceAuxPoint();
      this.OnWheel();
    }
  }
  GetPoints(): Vector3[] {
    return this.points;
  }
  OnWheel(e?: WheelEvent): void {
    if (this.points.length) {
      this.m_dimension.Line.SetDimension(
        this.originPoint,
        this.m_curPoint,
        this.scale
      );
      let xAxis = new THREE.Vector3(1, 0, 0);

      this.m_dimension.Arc.SetDimension(
        this.originPoint,
        xAxis,
        this.curDir,
        this.scale
      );
      this.updateDistanceAuxPoint();
    }
  }

  get auxPoint() {
    let ps: THREE.Vector3[] = [];
    this.m_auxPoints.forEach((x) => {
      ps.push(x.orgin);
    });
    return ps;
  }

  Finish(operate: DrawOperateState) {
    let auxPoints = [];
    if (this.AuxPointGroup.children.length) {
      let curVector = this.m_curPoint.clone().sub(this.points[0]).normalize();
      if (this.m_quadraturePoint) {
        curVector = this.m_quadraturePoint
          .clone()
          .sub(this.points[0])
          .normalize();
      }
      let angle = curVector.angleTo(new THREE.Vector3(1, 0, 0));
      if (curVector.clone().cross(new THREE.Vector3(1, 0, 0)).z > 0) {
        angle = -angle;
      }
      let quat = new THREE.Quaternion();
      quat.setFromAxisAngle(new THREE.Vector3(0, 0, 1), angle);
      let scale = new THREE.Vector3(1, 1, 1);
      if (!(this.m_specialParams.scale instanceof Object)) {
        scale.x = this.m_specialParams.scale;
        scale.y = this.m_specialParams.scale;
        scale.z = this.m_specialParams.scale;
      } else {
        scale.x = this.m_specialParams.scale.x;
        scale.y = this.m_specialParams.scale.y;
        scale.z = this.m_specialParams.scale.z;
      }
      for (let i = 0; i < this.AuxPointGroup.children.length; i++) {
        let auxPoint = this.AuxPointGroup.children[i];
        let matrix = new THREE.Matrix4();
        let position = auxPoint.position.clone();
        auxPoints.push(position);
        matrix.compose(position, quat, scale);
        this.SignMatrixs.push(matrix);
      }
    }
    this.clear();
    if (operate == DrawOperateState.complete) {
      if (this.points.length > 1) {
        let key = `${this.m_layer.Id}_${this.m_color}`;
        let lines: DbLine[] = this.m_model.Lines[key]?.lines ?? [];
        let ps: number[] = [];
        let index = 0;
        let indexs: number[] = [];
        let returnLine: DbLine | DBEntity[] = [];
        if (this.m_specialParams.isConnectingLine) {
          for (let i = 0; i < auxPoints.length; i++) {
            ps.push(auxPoints[i].x, auxPoints[i].y, auxPoints[i].z);
          }
          for (let i = 0; i < ps.length; i++) {
            if (i % 3 === 0 && i + 3 < ps.length) {
              let line = new DbLine({
                id: generateUUID(),
                layerId: this.m_layer.Id,
                blockId: "",
                points: new Float32Array([
                  ps[i],
                  ps[i + 1],
                  ps[i + 2],
                  ps[i + 3],
                  ps[i + 4],
                  ps[i + 5],
                ]),
                indexes: new Int32Array([0, 1]),
                color: this.m_color,
                extend_id: generateUUID(),
                block_path: generateUUID(),
              });
              line.getBoundingBox();
              line.getBoundingSphere();
              lines.push(line);
              returnLine!.push(line);
            }
          }
          if (this.m_model.Lines[key]) {
            this.m_model.Lines[key].lines = lines;
            this.view.m_context.ToolsManager.LinesToModel(
              lines,
              this.m_model.Lines[key].model
            );
          } else {
            this.m_model.Lines[key] = {
              canEdit: true,
              lines: lines,
              model: this.m_model.addLinesToModel(
                this.m_layer.Id,
                this.m_color,
                lines
              ),
            };
          }
        }

        return {
          dblines: returnLine,
          matrixs: this.SignMatrixs,
        };
      }
      return [];
    } else if (operate == DrawOperateState.cancel) {
      return [];
    }
    return undefined;
  }

  private get scale() {
    return this.view.ScreenModelScale;
  }
  // 辅助线
  private createdMoveLineAux() {
    this.drawLineAux = this.m_model.m_context.ToolsManager.CreatedAuxLine();
  }
  // 保护半径
  private createdProtectRadius() {
    if (this.m_specialParams.protectRadius.isCreate === false) {
      return;
    }
    let protectRadiusProject = new ProtectRadius(
      this.m_context,
      this.m_specialParams.protectRadius.radius
    ).ProtectRadiusProject;
    this.ProtectRadiusGroup.add(protectRadiusProject);
  }

  private updateProtectRadius() {
    if (this.m_specialParams.protectRadius.isCreate === false) {
      return;
    }
    this.AuxPointGroup.children.forEach((auxPoint, index) => {
      let protectRadius = this.ProtectRadiusGroup.children[index];
      if (protectRadius) {
        let position = auxPoint.position.clone();
        protectRadius.position.copy(position);
      }
    });
  }
  // 辅助标志
  private createdAuxPoint(position: THREE.Vector3 = new THREE.Vector3()) {
    let geo = new THREE.BufferGeometry();
    let positions = new Float32Array(37 * 3);
    for (let index = 0; index <= 36; index++) {
      let angle = (Math.PI * 2 * index) / 36;
      let x = Math.cos(angle) * 0.2;
      let y = Math.sin(angle) * 0.2;
      let z = 0;
      positions[index * 3] = x;
      positions[index * 3 + 1] = y;
      positions[index * 3 + 2] = z;
    }
    geo.setAttribute("position", new THREE.BufferAttribute(positions, 3));
    let material = new THREE.LineBasicMaterial({ color: CommonColor.White });
    let AuxPoint = new THREE.Line(geo, material);
    AuxPoint.position.copy(position);
    this.AuxPointGroup.add(AuxPoint);
  }

  // 创建距离标签
  private labelArray: ULabel[] = [];
  private createDistanceLabel() {
    let label = new ULabel(this.view, this.m_context.Dom);
    this.labelArray.push(label);
  }

  private updateDistanceAuxPoint(p: THREE.Vector3 = this.m_curPoint) {
    let curPoint = p;
    let distance = this.points[0].distanceTo(curPoint) * 1000;
    let { length } = this.AuxPointGroup.children;
    let { offWallDistance, maxInterval, minInterval } = this.m_specialParams;
    let radius1 = 0;
    let ave = distance / 2;
    let remainder = ave % 50;
    let le1 = ave - remainder;
    if (le1 > offWallDistance) {
      le1 = offWallDistance;
    }
    let le2 = distance - le1;
    let lx = 0;
    let dn = 0;
    let num = 0;
    if (distance > offWallDistance) {
      dn = (distance - offWallDistance) / maxInterval;
      // console.log(dn,'dn');
      let integer = Math.trunc(dn); // 整数部分
      let fractionalPart = dn - integer;
      if (integer > 0) {
        dn = integer + 1;
      } else {
        dn = integer;
        if (fractionalPart >= 0.1) {
          dn = integer + 1;
        }
      }
      // dn = integer + 1;
    }
    if (dn >= 1) {
      let dis1 = (distance - offWallDistance) / dn;
      let rem1 = dis1 % 50;
      lx = dis1 - rem1;
      let dis2 = (distance - lx * dn) / 2;
      let rem2 = dis2 % 50;
      le1 = dis2 - rem2;
      le2 = distance - le1 - lx * dn;
      // lx = (distance - offWallDistance * 2) / dn;
      // le1 = (distance - lx * dn) / 2;
      // le2 = distance - le1 - lx * dn;
      // console.log(lx, le1, le2, dn, distance);
    }
    radius1 = le1 / distance;
    num = dn + 1;
    if (num != length) {
      if (num >= length) {
        for (let i = 0; i < num - length; i++) {
          this.createdAuxPoint();
          this.createdProtectRadius();
        }
        for (let i = 0; i < dn + 2 - this.labelArray.length; i++) {
          this.createDistanceLabel();
        }
      } else {
        for (let i = num; i < length; i++) {
          let delItem = this.AuxPointGroup.children[i] as any;
          delItem?.geometry.dispose();
          delItem?.material.dispose();
          delItem?.removeFromParent();
          if (this.ProtectRadiusGroup.children.length) {
            let delItem = this.ProtectRadiusGroup.children[i] as any;
            delItem?.geometry.dispose();
            delItem?.material.dispose();
            delItem?.removeFromParent();
          }
        }
        if (dn !== 0) {
          for (let i = dn + 1; i < this.labelArray.length; i++) {
            let delItem = this.labelArray[i];
            delItem?.dispose();
            this.labelArray.splice(i, 1);
          }
        }
      }
    }
    let firstAuxPoint = this.AuxPointGroup.children[0];
    if (length > 1) {
      for (let i = 1; i < this.AuxPointGroup.children.length; i++) {
        let auxPoint = this.AuxPointGroup.children[i];
        let dis = i * lx + le1;
        let radius = dis / distance;
        let position = this.points[0].clone().lerp(curPoint.clone(), radius);
        auxPoint.position.copy(position);
      }
    }
    this.updateProtectRadius();

    for (let i = 0; i < this.labelArray.length; i++) {
      let label = this.labelArray[i];
      if (i == 0) {
        let radius = le1 / distance / 2;
        let pos = this.points[0].clone().lerp(curPoint.clone(), radius);
        label.SetVaule(le1.toString(), pos, new THREE.Vector3(1, 0, 0));
      } else if (i == this.labelArray.length - 1) {
        let radius = le2 / distance / 2;
        let pos = curPoint.clone().lerp(this.points[0].clone(), radius);
        label.SetVaule(
          le2.toFixed(0).toString(),
          pos,
          new THREE.Vector3(1, 0, 0)
        );
      } else {
        let dis = (i - 1) * lx + le1;
        let half = lx / 2;
        let radius = (dis + half) / distance;
        let pos = this.points[0].clone().lerp(curPoint.clone(), radius);
        label.SetVaule(
          lx.toFixed(0).toString(),
          pos,
          new THREE.Vector3(1, 0, 0)
        );
        if (lx == 0) label.Visibility = false;
        else label.Visibility = true;
      }
    }

    // console.log("dn=", dn, "le1=", le1, "le2=", le2, "lx=", lx);
    let position1 = this.points[0].clone().lerp(curPoint.clone(), radius1);
    firstAuxPoint.position.copy(position1);
  }
  private clear() {
    this.m_context.ToolsManager.ObjectsClear([
      this.m_locationObject,
      this.m_tempObject!,
      this.drawLineAux!,
    ]);
    this.m_dimension?.dispose();
    this.m_TextLabel?.dispose();
    this.m_context.ToolsManager.GroupClear(this.AuxPointGroup);
    this.m_context.ToolsManager.GroupClear(this.ProtectRadiusGroup);
    if (this.labelArray.length) {
      this.labelArray.forEach((label) => {
        label?.dispose();
      });
    }
  }
}

export { DrawLineLayout };
